import React, { useState, useEffect } from 'react';
import API_URL from '../config';

function Monitoring({ token }) {
  const [logs, setLogs] = useState([]);
  const [actionFilter, setActionFilter] = useState('');
  const [agentFilter, setAgentFilter] = useState('');
  const [agents, setAgents] = useState([]);
  const headers = { Authorization: `Bearer ${token}` };

  const fetchAgents = async () => {
    try {
      const res = await fetch(`${API_URL}/api/protected/agents`, { headers });
      if (res.ok) setAgents((await res.json()).agents || []);
    } catch (e) {}
  };

  const fetchLogs = async () => {
    const params = new URLSearchParams({ limit: '100' });
    if (actionFilter) params.set('action_type', actionFilter);
    if (agentFilter) params.set('agent_id', agentFilter);
    try {
      const res = await fetch(`${API_URL}/api/protected/logs?${params}`, { headers });
      if (res.ok) setLogs((await res.json()).logs || []);
    } catch (e) {}
  };

  useEffect(() => { fetchAgents(); }, [token]);
  useEffect(() => { fetchLogs(); const i = setInterval(fetchLogs, 3000); return () => clearInterval(i); }, [token, actionFilter, agentFilter]);

  const parseAction = (action) => {
    const parts = action.split(':');
    return { type: parts[0] || action, target: parts.slice(1).join(':') };
  };

  const actionBadge = (type) => {
    const map = {
      api_call: 'badge-info', llm_call: 'badge-info', llm_response: 'badge-info',
      tool_call: 'badge-purple', tool_use: 'badge-purple', function_call: 'badge-purple',
      web_search: 'badge-success', web_fetch: 'badge-success',
      file_read: 'badge-neutral', file_write: 'badge-warning', exec: 'badge-warning',
      message: 'badge-neutral', response: 'badge-neutral',
    };
    return <span className={`badge ${map[type] || 'badge-neutral'}`}>{type}</span>;
  };

  return (
    <>
      <div className="page-header">
        <div>
          <div className="page-title">Activity Log</div>
          <div className="page-subtitle">Real-time agent event stream</div>
        </div>
        <div className="page-actions">
          <span className="text-sm text-muted">{logs.length} events</span>
        </div>
      </div>
      <div className="page-body">
        <div className="card">
          <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
            {agents.length > 0 && (
              <select value={agentFilter} onChange={e => setAgentFilter(e.target.value)} style={{ maxWidth: 200 }}>
                <option value="">All agents</option>
                {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
              </select>
            )}
            <select value={actionFilter} onChange={e => setActionFilter(e.target.value)} style={{ maxWidth: 200 }}>
              <option value="">All actions</option>
              <optgroup label="LLM">
                <option value="llm_call">LLM Call</option>
                <option value="llm_response">LLM Response</option>
                <option value="api_call">API Call</option>
              </optgroup>
              <optgroup label="Tools">
                <option value="tool_call">Tool Call</option>
                <option value="tool_use">Tool Use</option>
                <option value="function_call">Function Call</option>
                <option value="web_search">Web Search</option>
                <option value="web_fetch">Web Fetch</option>
              </optgroup>
              <optgroup label="Files">
                <option value="file_read">File Read</option>
                <option value="file_write">File Write</option>
                <option value="exec">Exec</option>
              </optgroup>
              <optgroup label="Other">
                <option value="message">Message</option>
                <option value="response">Response</option>
              </optgroup>
            </select>
          </div>

          {logs.length === 0 ? (
            <div className="empty-state">
              <div className="empty-state-icon">&sim;</div>
              <h3>No activity recorded</h3>
              <p>Agent events will appear here in real-time once your agent starts working.</p>
            </div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Agent</th>
                  <th>Action</th>
                  <th>Target</th>
                  <th>Status</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(log => {
                  const { type, target } = parseAction(log.action);
                  return (
                    <tr key={log.id}>
                      <td style={{ fontWeight: 500, color: 'var(--text-primary)' }}>{log.agent_name || 'Unknown'}</td>
                      <td>{actionBadge(type)}</td>
                      <td>
                        <div className="truncate text-mono text-xs" style={{ maxWidth: 400 }}>{target || '-'}</div>
                      </td>
                      <td>
                        <span className={`badge ${log.status === 'success' ? 'badge-success' : 'badge-error'}`}>{log.status}</span>
                      </td>
                      <td className="text-sm text-muted">{new Date(log.timestamp).toLocaleString()}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}

export default Monitoring;
